import React from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://ojavana.com";
const LOCALES = ["en", "de", "fr"];

// Hreflang injects <link rel="alternate" hreflang="…"> tags into document.head
// for the current page. Tells Google these are language variants of the same content.
export default function Hreflang() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const ATTR = "data-oj-hreflang";

    // Remove any previously injected tags
    document.head.querySelectorAll(`link[${ATTR}]`).forEach((el) => el.remove());

    const make = (hreflang, href) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hreflang);
      link.setAttribute("href", href);
      link.setAttribute(ATTR, "1");
      document.head.appendChild(link);
    };

    LOCALES.forEach((lc) => make(lc, `${SITE}${path}?lang=${lc}`));
    make("x-default", `${SITE}${path}`);

    // canonical too
    const existingCanonical = document.head.querySelector(`link[rel="canonical"][${ATTR}]`);
    if (existingCanonical) existingCanonical.remove();
    const can = document.createElement("link");
    can.setAttribute("rel", "canonical");
    can.setAttribute("href", `${SITE}${path}`);
    can.setAttribute(ATTR, "1");
    document.head.appendChild(can);
  }, [pathname]);

  return null;
}
